import * as React from 'react';
import { useDispatch } from 'react-redux';
import { ISavedSearch } from '../../../types/savedSearch';
import { TThunkDispatch } from '../../../types/redux';
import { NotificationsContainer } from '../Notifications';
import { SavedSearchesList } from '../../../components/SavedSearches/MobileComponents/SavedSearchesList';
import { setSavedSearchesNotificationVisible } from '../../../actions/savedSearchesNotification';
import { MobileContent } from '../../../components/SavedSearches/MobileComponents/MobileContent';
import { changeTitleSavedSearch } from '../../../thunk/savedSearches/changeTitleSavedSearch';
import { deleteSavedSearches } from '../../../thunk/savedSearches/deleteSavedSearches';

interface IMobileSavedSearchesProps {
  searches: ISavedSearch[];
}

export const MobileSavedSearches: React.FC<IMobileSavedSearchesProps> = ({ searches }) => {
  const dispatch = useDispatch<TThunkDispatch>();

  const onSearchRemove = React.useCallback(
    (id: number) => {
      dispatch(deleteSavedSearches(id));
      dispatch(setSavedSearchesNotificationVisible({ visible: true }));
    },
    [dispatch],
  );

  const onSearchTitleChange = React.useCallback(
    (id: number, title: string) => {
      dispatch(changeTitleSavedSearch({ id, title }));
    },
    [dispatch],
  );

  return (
    <MobileContent>
      <NotificationsContainer />
      <SavedSearchesList
        savedSearches={searches}
        onSearchTitleChange={onSearchTitleChange}
        onSearchRemove={onSearchRemove}
      />
    </MobileContent>
  );
};
